if (!customElements.get("line-item-counter")) {
  customElements.define(
    "line-item-counter",
    class LineItemCounter extends HTMLElement {
      constructor() {
        super();
        this.onInput = this.onInput.bind(this);
      }

      connectedCallback() {
        this.field = this.querySelector("[data-li-field]");
        this.counter = this.querySelector("[data-li-counter]");
        this.template = this.dataset.counterTemplate || "";

        let max = parseInt(this.dataset.max, 10);
        if (isNaN(max) || max < 0) max = 0;
        this.max = max;

        if (!this.field || !this.counter || !this.max) return;

        this.field.addEventListener("input", this.onInput);
        this.field.addEventListener("change", this.onInput);
        this.render();
      }

      disconnectedCallback() {
        if (!this.field) return;
        this.field.removeEventListener("input", this.onInput);
        this.field.removeEventListener("change", this.onInput);
      }

      onInput() {
        this.render();
      }

      render() {
        const count = Math.min(this.field.value.length, this.max);
        this.counter.textContent = this.template.replace("%COUNT%", count);
      }
    },
  );
}
